import styled, { type StyledComponent } from '@emotion/styled';
import React from 'react';
import type { ITheme } from '../../themer';
import type { IArrowButtonProps } from '../Button/ArrowButton';
import { ButtonText } from '../Button/ButtonText';
import { type IIconButtonProps, StyledIconButton } from '../Button/IconButton';
import { ArrowIcon } from '../Icon';
import { Link } from './Link';

export interface IArrowLinkButtonProps extends IArrowButtonProps {
	href: string;
	rel?: string;
	target?: string;
	secondary?: boolean;
	hideExternalIndicator?: boolean;
}

interface IStyledIconLinkButton
	extends StyledComponent<IArrowLinkButtonProps, IIconButtonProps, ITheme> {}

export const StyledIconLinkButton = StyledIconButton.withComponent(
	Link,
) as IStyledIconLinkButton;

export const StyledArrowLinkButton = styled(StyledIconLinkButton)<{}, ITheme>`
	:hover {
		text-decoration: none;
	}
	&:focus-visible {
		border-radius: 2px;
		text-decoration: underline;
	}
`;

export const ArrowLinkButton = ({
	children,
	...props
}: IArrowLinkButtonProps) => (
	<StyledArrowLinkButton {...props}>
		<ButtonText>{children}</ButtonText>
		<ArrowIcon aria-hidden />
	</StyledArrowLinkButton>
);
